import { module } from 'modujs'
import { clamp, map } from '../utils/maths'

const BREAKPOINTS = {
    MEDIUM: 1000
}

export default class extends module {
    constructor(m) {
        super(m)

        // Binding
        this.onResizeBind = this.onResize.bind(this)

        // UI
        this.$el = this.el
        this.windowWidth = 0

        // Data
        this.data = {
            progress: 0,
            clip: {
                min: 0,
                max: 100,
                current: 0
            },
            scale: {
                min: 1,
                max: 1.3,
                current: 1.5
            }
        }
    }

    ///////////////
    // Lifecyle
    ///////////////
    init() {
        this.bindEvents()
        this.computeData()
        this.computeProgress()
    }

    destroy() {
        this.unbindEvents()
        super.destroy()
    }

    ///////////////
    // Events
    ///////////////
    bindEvents() {
        window.addEventListener('resizeEnd', this.onResizeBind)
    }

    unbindEvents() {
        window.removeEventListener('resizeEnd', this.onResizeBind)
    }

    ///////////////
    // Callbacks
    ///////////////
    onProgress(progress) {
        this.data.progress = progress
        this.computeProgress()
    }

    onResize() {
        this.computeData()
        this.computeProgress()
    }

    ///////////////
    // Methods
    ///////////////
    computeData() {
        this.windowWidth = window.innerWidth
    }

    computeProgress() {
        if (this.windowWidth < BREAKPOINTS.MEDIUM) {
            return
        }

        // Clip value
        this.data.clip.current = clamp(
            map(this.data.progress, 0, 1, this.data.clip.max, this.data.clip.min),
            this.data.clip.min, 
            this.data.clip.max
        )

        this.$el.style.setProperty('--clip', `${this.data.clip.current}%`)

        // Scale value
        this.data.scale.current = clamp(
            map(this.data.progress, 0, 1, this.data.scale.max, this.data.scale.min),
            this.data.scale.min, 
            this.data.scale.max
        )

        this.$el.style.setProperty('--scale', this.data.scale.current)
    }

    inview(e) {
        if (e.way == 'exit') {
            this.data.progress = window.scrollDirection == 'up' ? 0 : 1
            this.computeProgress()
        }
    }
}
